// src/components/ui/forms/FormTextArea/FormTextAreaShadcn.jsx
import React from 'react';

// shadcn components
import { Textarea } from '../../textarea';

import { cn } from '../../../../utils/cn';

const FormTextAreaShadcn = ({
  name,
  value,
  onChange,
  placeholder,
  rows = 3,
  required = false,
  disabled = false,
  variant = 'default', // 'default', 'emerald', 'blue'
  className = '',
  ...props
}) => {
  // Color variants (same as FormInput for consistency)
  const variants = {
    default: {
      focus: "focus:border-slate-500/50 focus:ring-slate-500/20"
    },
    emerald: {
      focus: "focus:border-emerald-500/50 focus:ring-emerald-500/20"
    },
    blue: {
      focus: "focus:border-blue-500/50 focus:ring-blue-500/20"
    }
  };

  const variantStyles = variants[variant];

  return (
    <Textarea
      name={name}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      rows={rows}
      required={required}
      disabled={disabled}
      className={cn(
        // Additional custom styling
        "px-4 py-3 rounded-lg transition-all duration-200 resize-none",
        "bg-slate-700/50 border-slate-600/50",
        "hover:border-slate-500/50",

        // Variant-specific colors
        variantStyles.focus,

        className
      )}
      {...props}
    />
  );
};

export default FormTextAreaShadcn;